
export function getStatusColor (status) {
    switch (parseInt(status)) {
    case 1:
        return 'dark:text-yellow-400 text-yellow-500'
    case 2:
        return 'dark:text-yellow-400 text-yellow-500'
    case 3:
        return 'dark:text-red-600 text-red-600'
    case 4:
        return 'dark:text-red-600 text-red-600'
    case 5:
        return 'dark:text-indigo-600 text-indigo-600'
    case 6:
        return 'dark:text-green-400 text-green-500'
    case 7:
        return 'dark:text-red-600 text-red-600'
    case 8:
        return 'dark:text-blue-500 text-blue-600'
    case 9:
        return 'dark:text-gray-400 text-gray-700'
    case 10:
        return 'dark:text-red-600 text-red-600'
    case 11:
        return 'dark:text-yellow-400 text-yellow-500'
    case 12:
        return 'dark:text-green-400 text-green-500'
    case 13:
        return 'dark:text-blue-500 text-blue-600'
    case 14:
        return 'dark:text-yellow-400 text-yellow-500'
    default:
        break
    }
}
